import HttpStatus from 'http-status-codes'
import moment from 'moment'

import { api } from '../services/api'
import { initializeUsabilla } from '../services/usabilla'
import { mixpanel } from '../services/telemetry/mixpanel'
import { amplitude } from '../services/telemetry/amplitude'
import { setOtelUserMetadata } from '../services/telemetry/splunk'
import { urls } from '../utils/urls'
import store from '../store/reduxStore'

export const getUser = () => {
  return dispatch => {
    api.get('/user')
      .then(({ data }) => {
        // Handle case where data is null (e.g., when password is expired)
        if (!data) {
          return
        }
        dispatch({ type: 'SET_CURRENT_USER', data })
        setOtelUserMetadata(data)
        mixpanel.identify(data)
        mixpanel.registerUserSupers(data)
        amplitude.identify(data)
        amplitude.registerUserSupers(data)
        initializeUsabilla(data)
      })
  }
}

export const optOutOfBeta = () => {
  return dispatch => {
    api.put('/features/beta', { enabled: false })
      .then(() => {
        dispatch({ type: 'OPTED_OUT_OF_BETA' })
      })
      .catch(() => { })
  }
}

export const getSystemNotifications = () => {
  return dispatch => {

    api.get('/system_notifications')
      .then(({ data }) => {
        // Handle case where data is null (e.g., when password is expired)
        if (!data || !data.systemNotifications) {
          return
        }
        dispatch({
          type: 'SET_SYSTEM_NOTIFICATIONS', data: {
            systemNotifications: data.systemNotifications
          }
        })
      })
      .catch(() => { })
  }
}

export const markSystemNotificationAsRead = id => {
  return dispatch => {
    const state = store.getState()

    dispatch({
      type: 'SET_SYSTEM_NOTIFICATIONS', data: {
        systemNotifications: state.user.systemNotifications.filter(notification => notification.id !== id)
      }
    })

    api.post('/notifications/requests/mark_read', { system_notification_ids: [ id ]})
      .catch(() => { })
  }
}

export const sendVerificationEmail = ({ successMessage, warningMessage, errorMessage }) => {
  return dispatch => {
    api.post('/auth/requests/email_verification')
      .then(({ data }) => {
        dispatch({ type: 'GET_SENT_EMAIL_STATUS_SUCCESS', data: { remainingSeconds: data.remainingSeconds }})
        if (data.status && data.status === 'error') {
          return dispatch({
            type: 'SHOW_TOAST', data: {
              type: 'error',
              title: data.message
            }
          })
        }
        dispatch({
          type: 'SHOW_TOAST', data: {
            type: 'success',
            title: successMessage
          }
        })
      })
      .catch(err => {
        const status = err.response && err.response.status
        if (status === HttpStatus.FORBIDDEN) {
          return dispatch({
            type: 'SHOW_TOAST', data: {
              type: 'warning',
              title: warningMessage
            }
          })
        }
        dispatch({
          type: 'SHOW_TOAST', data: {
            type: 'error',
            title: errorMessage
          }
        })
      })
  }
}

export const getSentEmailStatus = () => {
  return async dispatch => {
    try {
      const response = await api.get('/auth/requests/email_verification/last_sent')
      const { data } = response
      dispatch({ type: 'GET_SENT_EMAIL_STATUS_SUCCESS', data: { remainingSeconds: data.remainingSeconds }})
      if (data.status && data.status === 'error') {
        return dispatch({
          type: 'SHOW_TOAST', data: {
            type: 'error',
            title: data.message
          }
        })
      }
    } catch (error) {
      dispatch({ type: 'GET_SENT_EMAIL_STATUS_FAILURE', data: { error }})
    }
  }
}

export const sendUserUseCase = data => {
  return async dispatch => {
    try {
      // remove empty values from request body
      Object.keys(data).forEach(key => (data[key] === null || data[key]?.length === 0) && delete data[key])

      await api.post('/user/requests/update_use_case', data)
      dispatch({ type: 'SET_CURRENT_USER', data: { dateUseCaseAsked: moment().format('YYYY-MM-DD') }})
    } catch (e) {
      // will not prevent user from closing the modal for now
    } finally {
      dispatch({ type: 'CLOSE_MODAL' })
    }
  }
}

export const changePassword = (oldPassword, newPassword, confirmPassword) => {
  return dispatch => {
    dispatch({ type: 'CHANGE_PASSWORD_REQUEST' })

    return api.put('/user/password', {
      old_password: oldPassword,
      password: newPassword,
      confirm: confirmPassword
    })
      .then(() => {
        dispatch({ type: 'CHANGE_PASSWORD_SUCCESS' })
        dispatch({ type: 'PASSWORD_RESET_SUCCESS' })
        // Redirect to form manager after successful password change
        window.location.href = urls.FORM_MANAGER
      })
      .catch((error) => {
        // API returns errors in format: { errors: [{ issue_code, issue_code_description }] }
        const errors = error.response?.data?.errors
        const errorMessage = errors && errors.length > 0
          ? errors[0].issue_code_description || errors[0].issue_code
          : error.response?.data?.error ||
            error.response?.data?.message ||
            'Failed to change password'
        dispatch({
          type: 'CHANGE_PASSWORD_ERROR',
          data: errorMessage
        })
        throw new Error(errorMessage)
      })
  }
}
